import styled from 'styled-components';

import type {
  WrapperComponent,
} from '../types';

export const Wrapper: WrapperComponent = styled.div({
  position: 'relative',
});
